import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useAuth from '../../hooks/useAuth';
import { getStorage } from '../../utils/storage';
import { ACCESS_TOKEN } from '../../store/types';
import { PATH_CONFIG } from '../../router/paths';


const getUserRoleAuthStatus = (pathname, user, routes) => {
  const matched = routes.find((r) => r.path === pathname);
  const authenticated =
      matched && matched.auth && matched.auth.length ? matched.auth.includes(user.roles) : false;
  return authenticated;
};

export const AdminRequireAuth = ({ permission, children }) => {
  const accessToken = getStorage(ACCESS_TOKEN);
  const { profile } = useAuth();
  const { pathname } = useLocation();

  const { account } = useSelector((state) => state);


  // const isUserRoleAuthenticated = getUserRoleAuthStatus(pathname, user, routes);
  // const isUserRoleAuthenticated = profile && profile.roles && Array.isArray(profile.roles);
  if (accessToken || PATH_CONFIG?.permissions?.includes(pathname)) {
    return children;
  }
  // /honhai/app?redirect=${encodeURIComponent(location.pathname)}`}
  return <Navigate to={`/honhai/app?redirect=${encodeURIComponent(pathname)}`}  replace />;
};

export const SuperAdminRequireAuth = ({ permission, children }) => {
  const { user, routes } = useAuth();
  const { pathname } = useLocation();
  const { routers } = useSelector((state) => state.menus);
  return '404';
};

export const SaRequireAuth = ({ permission, children }) => {
  const { user, routes } = useAuth();
  const { pathname } = useLocation();
  const { routers } = useSelector((state) => state.menus);
  return '404';
};

export const GuestRequireAuth = ({ permission, children }) => {
  const { user, routes } = useAuth();
  const { pathname } = useLocation();
  const { routers } = useSelector((state) => state.menus);
  return '404';
};

export const ScreenRequireAuth = ({ permission, children }) => {
  const { account, routes } = useAuth();
  const { pathname } = useLocation();
  const { routers } = useSelector((state) => state.menus);
  return <Navigate to="/sessions/404" />;
};
